import { Col, Divider, Row } from 'antd';
import {
  // ORDER_TYPE,
  PAYMENT_STATUSES,
  PAYMENT_TYPES,
} from 'constants/constants';
import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from 'utils/formattedString';

const getShippingType = (shippingType) => {
  if (['in3Days', 'in1Day', 'in2h'].includes(shippingType))
    return `orders.shippingType.${shippingType}`;
  return shippingType;
};

export default function OrderSummary({ data }) {
  const { t } = useTranslation();
  // const paymentStatus = PAYMENT_STATUSES.find(e => e.value === data?.paymentStatus)
  // const dispatch = useDispatch();

  const paymentStatus = PAYMENT_STATUSES.find(
    (e) =>
      // e.value ===
      //   data?.payments?.filter((e) => e.type !== 'point')?.[0]?.status ||
      e.value === data?.paymentStatus,
  );

  const summaries = [
    // {
    //   text: (data?.statusOms === 'fulfillment' && data?.fulfillmentPartner === 'BOXME' && data?.statusFulfillment && data?.statusFulfillment !== 'CREATED' && data?.statusFulfillment !== 'PENDING' && !isPendingOrders(data)) ? 'orders.fulfillmentStatus' : 'orders.status',
    //   value:
    //     (data?.statusOms === 'fulfillment' && data?.fulfillmentPartner === 'BOXME' && data?.statusFulfillment && data?.statusFulfillment !== 'CREATED' && data?.statusFulfillment !== 'PENDING' && !isPendingOrders(data)) ? (
    //       <VendorStatusLabel record={data} />
    //       ) : (
    //       <OrderStatusLabel record={data} />
    //     ),
    // },
    // ...(data?.statusOms !== 'cancelled' && (data?.statusOms !== 'reject' || !data?.isUndoSo) && data?.fulfillmentPartner === 'BOXME' && data?.statusOms === 'fulfillment' && data?.statusFulfillment && data?.statusFulfillment !== 'CREATED' && data?.statusFulfillment !== 'PENDING' && isPendingOrders(data)) ? [
    //   {
    //     text: 'orders.fulfillmentStatus',
    //     value: <VendorStatusLabel record={data} />,
    //   },
    // ] : [],
    // {
    //   text: 'orderDetail.createdTime',
    //   value: formatDateTime(data?.createdAt),
    // },
    {
      key: 1,
      text: 'orders.paymentType',
      value: data?.payments?.length
        ? data?.payments
            ?.filter((e) => e.type !== 'point')
            ?.map(
              (payment) =>
                t(
                  [
                    ...PAYMENT_TYPES,
                    { value: 'bank', text: 'Bank' },
                    { value: 'other', text: 'Other' },
                  ].find((e) => e.value === payment.type)?.text,
                ) || payment?.paymentDetail?.method,
            )
            ?.join(', ')
        : t(
            [
              ...PAYMENT_TYPES,
              { value: 'bank', text: 'Bank' },
              { value: 'other', text: 'Other' },
            ].find((e) => e.value === data?.paymentType)?.text,
          ),
    },
    {
      key: 2,
      text: 'orderDetail.paymentStatus',
      value: t(paymentStatus?.text),
      color: paymentStatus?.color,
    },
    {
      key: 3,
      text: 'orderDetail.channel',
      value: upperFirst(data?.channelDisplay),
    },
    // ...(data?.locationId && data?.customerOrderId
    //   ? [
    //       {
    //         text: 'orders.warehouse',
    //         value: data?.locationId,
    //       },
    //     ]
    //   : []),
    {
      key: 4,
      text: 'orders.warehouse',
      value: (
        <span> {`${data?.location?.code} | ${data?.location?.name}`}</span>
      ),
    },
    ...(data?.deliveryType !== 'EXTERNAL'
      ? [
          {
            key: 5,
            text: 'Delivery Method',
            value: t(getShippingType(data?.shippingType)),
          },
        ]
      : [
          {
            key: 5,
            text: 'Delivery Type',
            value: 'External',
          },
        ]),
    // {
    //   text: 'Shipping Type',
    //   value: (
    //     <span className="text-active-grey fw-600">
    //       {/* {ORDER_TYPE?.find((item) => item?.value === data?.orderType)?.text} */}
    //       {t(getShippingType(data?.shippingType))}
    //     </span>
    //   ),
    // },
    // ...data?.fulfillmentPartner ? [
    //   {
    //     text: 'orders.fulfillment',
    //     value: data?.fulfillmentPartner,
    //   },
    // ] : [],
    // ...data?.fulfillmentPartnerCode ? [
    //   {
    //     text: 'orders.fulfillmentPartnerCode',
    //     value: data?.fulfillmentPartnerCode,
    //   },
    // ] : [],
    // ...data?.fulfillmentPartnerCodeReject ? [
    //   {
    //     text: 'orders.fulfillmentPartnerCodeReject',
    //     value: data?.fulfillmentPartnerCodeReject,
    //   },
    // ] : [],
    // ...data?.isFulfillNow ? [
    //   {
    //     text: `orders.packagedService`,
    //     value: t('orders.isFulfillNow'),
    //   },
    // ] : [],
    // ...data?.isFulfillPriority ? [
    //   {
    //     text: `orders.packagedService`,
    //     value: t('orders.isFulfillPriority'),
    //   },
    // ] : [],
  ];

  return (
    <div className="w-full summary-container mt-[20px]">
      <div className="summary-container__data">
        <Row>
          <Col md={4}>
            <div>
              <div className="mb-[5px] text-highlight opacity-50">
                {t('orderDetail.createdTime')}
              </div>
              <div className="text-[14px] fw-600 text-highlight">
                {formatDateTime(data?.createdAt)}
              </div>
            </div>
          </Col>

          {summaries.map((e, index) => (
            <Col md={4} key={`${String(e?.key)}-${index}`}>
              <div className="flex justify-center items-center">
                <Divider style={{ height: '100%' }} type="vertical" />
                <div>
                  <div className="mb-[5px] text-highlight opacity-50">
                    {t(e.text)}
                  </div>
                  <div
                    className="text-[14px] fw-600 text-highlight"
                    style={{
                      color: e?.color,
                    }}
                  >
                    {e?.value}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
